module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.to')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content"
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": true,
      "placeholder": "Email to",
      "multiple": true
    },
    model: {
      value: (_vm.previewEmailTo),
      callback: function($$v) {
        _vm.previewEmailTo = $$v
      },
      expression: "previewEmailTo"
    }
  }, _vm._l((_vm.previewEmailTo), function(email, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": email,
        "value": email
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(" CC:")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content"
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": true,
      "placeholder": "Email cc",
      "multiple": true,
      "popper-class": "ccEmail hidden"
    },
    model: {
      value: (_vm.previewEmailCC),
      callback: function($$v) {
        _vm.previewEmailCC = $$v
      },
      expression: "previewEmailCC"
    }
  }, _vm._l((_vm.previewEmailCC), function(email, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": email,
        "value": email
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.subject')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content"
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "name": "subject"
    },
    model: {
      value: (_vm.previewSubject),
      callback: function($$v) {
        _vm.previewSubject = $$v
      },
      expression: "previewSubject"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "el-textarea margin-b-10"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(" " + _vm._s(_vm.$t('static.bills.edit.messageBody')) + ":")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.previewMessage),
      expression: "previewMessage"
    }],
    staticClass: "el-textarea__inner",
    attrs: {
      "disabled": "disabled",
      "rows": "10",
      "name": "message"
    },
    domProps: {
      "value": (_vm.previewMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.previewMessage = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c4777cb","hasScoped":false}!./src/app/components/previewMessageCopy/previewMessageCopy.html
// module id = 3026
// module chunks = 1